import { useParams } from "react-router"

import { useActiveOrganizationId } from "@/contexts"
import { isAdminEntityUnavailable } from "@/modules/admin/utils/is-admin-entity-unavailable"
import { isUnavailableSiteError, useGetSite } from "@/services/site"
import { parseModelId } from "@/utils/parse-model-id"

export const useAdminSitePageState = () => {
  const { activeOrganizationId } = useActiveOrganizationId()
  const { siteId: siteIdParam } = useParams()

  const siteId = parseModelId(siteIdParam)
  const organizationId = activeOrganizationId ?? ""

  const {
    siteData,
    siteError,
    siteIsFetched,
    siteIsFetching,
    siteIsLoading,
    ...siteQueryResult
  } = useGetSite(siteId === undefined ? undefined : String(siteId), {
    organizationId,
    queryOptions: {
      enabled: Boolean(organizationId) && siteId !== undefined,
    },
  })

  const siteIsUnavailable = isAdminEntityUnavailable({
    data: siteData,
    error: siteError,
    id: siteId,
    isFetched: siteIsFetched,
    isUnavailableError: isUnavailableSiteError,
  })

  return {
    ...siteQueryResult,
    siteData,
    siteError,
    siteId,
    siteIsFetched,
    siteIsFetching,
    siteIsLoading,
    siteIsUnavailable,
  }
}
